import { Text } from 'components/typography';
import * as React from 'react';
import { useIntl } from 'react-intl';

import CloseIcon from 'icons/CloseIcon';

type DismissibleTagProps = {
  text: string;
  className?: string;
  closeButtonAriaLabel?: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
};

const DismissibleTag = ({
  className = '',
  onClick,
  text,
  closeButtonAriaLabel,
  ...props
}: DismissibleTagProps): React.ReactNode => {
  const intl = useIntl();
  const closeButtonAriaLabelDefault = intl.formatMessage(
    { defaultMessage: `Dismiss {text} filter` },
    { text }
  );

  return (
    <div
      className={`inline-flex select-none items-center justify-center rounded-full border-thin border-black border-opacity-16 pb-1 pl-3 pr-1 pt-1 xl:pb-2 xl:pl-4 xl:pr-2 xl:pt-2 ${className}`}
      {...props}
    >
      <Text size="m" className="whitespace-nowrap" aria-hidden>
        {text}
      </Text>
      <button
        type="button"
        className="ml-3 rounded-full"
        onClick={onClick}
        aria-label={closeButtonAriaLabel || closeButtonAriaLabelDefault}
      >
        <CloseIcon
          variant="background"
          className="close-icon size-6"
          ariaHidden
        />
      </button>
    </div>
  );
};

export default DismissibleTag;
